import React from 'react'

export default function TimeTable() {
  return (
    <div className='container'>
      <h1 className="text-center mb-4 text-blue">Membotic Timetable</h1>
      <button
        className="floating-back-button"
        onClick={() => window.history.back()}
      >
        ← Back
      </button>
      <div className="row my-4 px-3">
  <div className="col-md-6 mb-3">
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body d-flex">
        <div className="me-3 fs-3 text-primary">
          <i className="bi bi-briefcase-fill"></i>
        </div>
        <div>
          <h5 className="text-blue fw-bold">Business Use</h5>
          <p className="card-text mb-0">
            Clubs and instructors can easily manage class schedules, monitor bookings, and optimize capacity planning.
            The timetable provides a clear overview of daily sessions, helping businesses avoid overbooking and better
            serve their members.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div className="col-md-6 mb-3">
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body d-flex">
        <div className="me-3 fs-3 text-success">
          <i className="bi bi-people-fill"></i>
        </div>
        <div>
          <h5 className="text-blue fw-bold">General Use</h5>
          <p className="card-text mb-0">
            Members can view upcoming classes, see availability, and book sessions instantly. The timetable helps users
            stay organized and ensures they never miss a workout or event they’re interested in.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>



      <div className="mb-2 pb-2 bg-white">
        <div className="customNav row mx-2">
          <div className="col mt-2">
            <p className="fw-bold fontSize20">Classes</p>
          </div>
          <div className="col mt-3">
            <p>May 6 - May 12</p>
          </div>
          <div className="col d-flex justify-content-end mt-3">
            <div className="d-flex mx-3 cursor-pointer">
              <p>Previous</p>
            </div>
            <div className="d-flex cursor-pointer">
              <p>Next</p>
            </div>
          </div>
        </div>

        <div className="row timetable mx-5">
          {/* Monday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Monday</p>
              <p className="mb-0">6 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">Yoga</p>
                <p className="fontSize12">Relaxing full-body flow</p>
                <p className="fontSize14">Time in: 10:00</p>
                <p className="fontSize14">Time out: 11:00</p>
                <p>Spaces left: 5</p>
                <p className="book-button mx-2 mt-2 mb-4">Book now</p>
              </div>
            </div>
          </div>

          {/* Tuesday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Tuesday</p>
              <p className="mb-0">7 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">HIIT</p>
                <p className="fontSize12">High-intensity cardio blast</p>
                <p className="fontSize14">Time in: 18:00</p>
                <p className="fontSize14">Time out: 18:45</p>
                <p>Spaces left: 0</p>
                <p className="booked-button mx-2 mt-2 mb-4">Fully booked</p>
              </div>
            </div>
          </div>

          {/* Wednesday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Wednesday</p>
              <p className="mb-0">8 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">Pilates</p>
                <p className="fontSize12">Core strengthening class</p>
                <p className="fontSize14">Time in: 14:30</p>
                <p className="fontSize14">Time out: 15:15</p>
                <p>Spaces left: 2</p>
                <p className="book-button mx-2 mt-2 mb-4">Book now</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}
